import { h } from 'preact';

const Shop = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" role="img" {...props}>
			<path d="M20.7 21.7c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2 2.2-1 2.2-2.2-1-2.2-2.2-2.2M2.8 3.8V6H5l4 8.5-1.5 2.7c-.2.3-.3.7-.3 1.1 0 1.2 1 2.2 2.2 2.2h13.4v-2.2h-13q-.3 0-.3-.3v-.1l1-1.8h8.3c.8 0 1.6-.5 2-1.2l4-7.2c0-.2.1-.4.1-.6 0-.6-.5-1.1-1.1-1.1H7.5L6.4 3.8m3.1 17.9c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2 2.2-1 2.2-2.2-1-2.2-2.2-2.2" />
		</svg>
	);
};

export default Shop;